export default "__VITE_ASSET__DdsZZrjv__"